<form #imageForm="ngForm" enctype="multipart/form-data" (ngSubmit)="upload()">
  <div class="container" fxLayout="column" fxLayoutAlign="start stretch">
    <mat-card-header class="heading">Image Preview</mat-card-header>

    <div class="image-preview-div">
      <div class="image-preview" *ngIf="uploadedImage">
        <img [src]="uploadedImage" alt="Uploaded Image" class="uploaded-image" (load)="getImageDimensions($event)" *ngIf="!isCropping">
      </div>

      <div *ngIf="imageWidth !== 0 && imageHeight !== 0" class="dimension">
        <p>{{ imageWidth }} x {{ imageHeight }}</p>
      </div>

      <div *ngIf="isCropping">
        <image-cropper
          [imageBase64]="uploadedImage ? getBase64Image(uploadedImage) : undefined"
          [maintainAspectRatio]="true"
          [aspectRatio]="712 / 200"
          format="png"
          (imageCropped)="imageCropped($event)"
        ></image-cropper>
      </div>
    </div>

    <div fxLayout="row wrap" fxLayoutAlign="end" class="buttons">
      <button mat-raised-button type="button" class="reset-button" (click)="resetImage()">Reset</button>
      <button mat-raised-button type="button" class="crop-button" (click)="toggleCropping()">Crop</button>
    </div>

    <div class="image-detail">
      <div fxLayout="row wrap" fxLayoutGap="30px" class="input-row">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="55">
          <mat-card-header>Image Title</mat-card-header><br>
          <input type="text" [placeholder]="selectedLanguage === 'fr' ? 'Enter the Image Title in French' : 'Enter the Image Title in English'" class="title-input" [(ngModel)]="enteredTitle" name="enteredTitle" [disabled]="selectedImageType === 'banner'"/>
          <div *ngIf="invalidTitleError" class="error-message">{{ invalidTitleError }}</div>
        </div>

        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="40">
          <mat-card-header>Image Type</mat-card-header><br>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Select Image Type" [(ngModel)]="selectedImageType" name="selectedImageType" (ngModelChange)="handleImageTypeChange($event)">
              <mat-option value="banner">Banner</mat-option>
              <mat-option value="explorer">Explorer</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="30px" class="input-row">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="55">
          <mat-card-header>Image Description</mat-card-header><br>
          <input type="text" [placeholder]="selectedLanguage === 'fr' ? 'Enter the Image Description in French' : 'Enter the Image Description in English'" class="description-input" [(ngModel)]="enteredDescription" name="enteredDescription" [disabled]="selectedImageType === 'banner'">
          <div *ngIf="invalidDescriptionError" class="error-message">{{ invalidDescriptionError }}</div>
        </div>

        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="40">
          <mat-card-header>Language</mat-card-header><br>
          <mat-form-field appearance="outline">
            <mat-select placeholder="Select Language" [(ngModel)]="selectedLanguage" name="selectedLanguage">
              <mat-option value="en">English</mat-option>
              <mat-option value="fr">French</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="30px" class="input-row">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="55">
          <mat-card-header>Start Date</mat-card-header><br>
          <input type="datetime-local" class="date-input" [(ngModel)]="enteredStartDate" name="enteredStartDate">
        </div>

        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="40">
          <mat-card-header>End Date</mat-card-header><br>
          <input type="datetime-local" class="date-input" [(ngModel)]="enteredEndDate" name="enteredEndDate">
        </div>
      </div>

      <div *ngIf="dateError" class="error-message">{{ dateError }}</div>

      <div fxLayout="row wrap" fxLayoutGap="30px" class="input-row">
        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="55">
          <mat-card-header class="header">Redirect Link</mat-card-header><br>
          <input type="url" placeholder="Enter URL" class="url-input" [(ngModel)]="redirectLink" name="redirectLink">
          <div *ngIf="redirectLinkError" class="error-message">{{ redirectLinkError }}</div>
        </div>

        <div fxLayout="column" fxFlex="100" fxFlex.gt-sm="40">
          <mat-card-header class="header">Button Text</mat-card-header><br>
          <input type="text" [placeholder]="selectedLanguage === 'fr' ? 'Enter the Button Text in French' : 'Enter the Button Text in English'" class="button-input" [(ngModel)]="buttonText" name="buttonText" [disabled]="selectedImageType === 'banner'" />
        </div>
      </div>
    </div>

    <div *ngIf="Error" class="error-message">{{ Error }}</div>

    <div fxLayout="row" fxLayoutAlign="end">
      <button mat-raised-button class="cancel-button" [routerLink]="['/upload']" type="button">Cancel</button>
      <button mat-raised-button class="upload-button" type="submit">Upload</button>
    </div>
  </div>
</form>
